export var API_STATUS_CODE = {
    SUCCESS: '00000',
};
export var ACTION = {
    DELETE: 'delete',
    NEW: 'new',
};
